import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelSsins.mjs'
import SsInsStatus from './SsInsStatus.mjs'

const PropertiesPaneSsins = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <Text prop="ssInsName" />
                <LongText prop="ssInsDesc" />
                <LongText prop="ssInsMemo" />
                <Text prop="ssInsPort" />

                <Select
                    options={SsInsStatus}
                    prop="ssInsStatus"
                />

                <Text prop="ssInsBu" />
                <Text prop="ssInsDm" />
                <Text prop="ssInsOm" />
                <Text prop="ssInsEnv" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneSsins
